export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/professional/privacy-policy/index.js